const leaflets = {
    "burghybar": {
        "config": {
            "primary-color": "#F7AD3C",
            "secondary-color": "#41AC50",
            "tertiary-color": "#ffdd00",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "primary-alpha-color": "rgba(35, 94, 157, 0.7)",
            "clientIcon": require("assets/images/BurghyBar-icona.png"),
            "serverPath": "burghybar.menuinterattivo.net/",
            "pdfPath": "/media/pdf/menu.pdf",
            "shareFlyerTitle": "Menù interattivo",
            "shareFlyerURL": "burghybar.menuinterattivo.net",
            "shareProductSentence": "Guarda il menù di Burghy Bar!",
            "ogTitleMeta": "Menù interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al menù interattivo di burghy Bar.",
            "ogImageMeta": "https://burghybar.menuinterattivo.net/media/images/BurghyBar_fb_01.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "UA-152069090-16",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 20,
            "client_id": 12,
            "signboard_id": 16,
            "has_pages": true,
            "hide_grocery_list": true,
            "hide_searchbar": true,
            "line_through": false,
            "category_banner": "",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "menu"

        },

        "leaflet": {
    "name": "BurghyBar_Menù",
    "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/Menu_Interattivo_Burghy_bar-ok_9DNXQSP.png",
        "links": [
            {
                "page": 2,
                "blueprint": {
                    "top": 40.67821779050003,
                    "left": 8.412778904665313,
                    "width": 82.63184584178498,
                    "height": 5.256140483908677
                }
            },
            {
                "page": 3,
                "blueprint": {
                    "top": 48.588968297599415,
                    "left": 8.86494252873563,
                    "width": 82.63184584178498,
                    "height": 5.256140483908677
                }
            },
            {
                "page": 5,
                "blueprint": {
                    "top": 56.83778506568597,
                    "left": 8.503211629479376,
                    "width": 82.63184584178498,
                    "height": 5.256140483908677
                }
            },
            {
                "page": 6,
                "blueprint": {
                    "top": 64.88376207718022,
                    "left": 8.774509803921568,
                    "width": 82.63184584178498,
                    "height": 5.256140483908677
                }
            }
        ]
    },
    "categories": [],
    "pages": [
        {
            "number": 1,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/page_1_jnY5vAH.jpg",
            "products": []
        },
        {
            "number": 2,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/page_2_16kxxT9.jpg",
            "products": []
        },
        {
            "number": 3,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/page_3_tSxz2Fs.jpg",
            "products": []
        },
        {
            "number": 4,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/page_4_6IYmKP1.jpg",
            "products": []
        },
        {
            "number": 5,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/page_5_EejikzA.jpg",
            "products": []
        },
        {
            "number": 6,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/page_6_0steaPT.jpg",
            "products": []
        },
        {
            "number": 7,
            "image_file": "https://interattivo.s3.amazonaws.com/XN4dSXzNp7/pages/fine_Interattivo_Birghy_bar-02_yMiIb0p.png",
            "products": []
        }
    ]
}
    }

}

const lefletSwitch = () => {
    return leaflets.burghybar;
}

export const serverResponse = lefletSwitch(); 